import React from "react";
import styles from "./CardLoader.module.css";

const CardLoader = ({ menuOpenStatus }) => {
  return (
    <div
      className={`fixed z-[950] top-0 right-0 bottom-0 left-0 Xbg-red-500
                  flex flex-col items-center justify-center
                  transition-all duration-200
                  ${
                    menuOpenStatus
                      ? "md:pl-[6.5rem] ip11l:pl-[25.5rem]"
                      : "md:pl-[6.5rem]"
                  }
                 `}
    >
      <div className={styles["loader"]} />
    </div>
  );
};

export default CardLoader;
